<template>
     <div class="openserviceorder-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Service Order Control" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="openserviceorder-id" 
                type="hidden" 
                v-model="openserviceorder.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Date:"
                    label-for="openserviceorder-date_open_service"
                    >
                    <b-form-input
                    id="openserviceorder-date_open_service"
                    type="date"
                    v-model="openserviceorder.date_open_service"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Property:" 
                        label-for="openserviceorder-immobile_id_open_service">
                        <b-select 
                            id="openserviceorder-immobile_id_open_service"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="immobiles" 
                            @input="getImmobile(openserviceorder.immobile_id_open_service)"
                            v-model="openserviceorder.immobile_id_open_service" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                <b-col md="10" sm="12">
                    <b-form-group 
                            label="Location:" 
                            label-for="openserviceorder-description_open_service">
                        <b-form-input id="openserviceorder-description_open_service" 
                            type="text"
                            v-model="openserviceorder.description_open_service" 
                            size="sm"
                            placeholder="Location..." />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row>
             <b-col md="8" sm="12">
                    <b-form-group 
                        label="Service Provider:" 
                        label-for="openserviceorder-service_provider_id_open_service">
                        <b-select 
                            id="openserviceorder-service_provider_id_open_service"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="serviceproviders" 
                            v-model="openserviceorder.service_provider_id_open_service" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
             <b-col md="8" sm="12">
                    <b-form-group 
                        label="Service:" 
                        label-for="openserviceorder-default_service_type_id_open_service">
                        <b-select 
                            id="openserviceorder-default_service_type_id_open_service"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="defaultservicetypes" 
                            v-model="openserviceorder.default_service_type_id_open_service" 
                            />
                    </b-form-group>
                </b-col> 
                <b-col md="2" sm="12">
                    <b-form-group
                        label="Value Hour:"
                        label-for="openserviceorder-value_hours_open_service"
                    >
                        <b-form-input
                            id="openserviceorder-value_hours_open_service"
                            type="number"
                            v-model="openserviceorder.value_hours_open_service"
                            size="sm"
                            step="0.02"
                                :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
                </b-col>
             </b-row>
            <b-row>
                 <b-col md="8" sm="12">
                        <b-form-group 
                            label="Comments:" 
                            label-for="openserviceorder-comments_financial_control">
                        <b-form-textarea id="openserviceorder-comments_financial_control"
                            :rows="3"
                            :max-rows="6"
                            size="sm"
                            v-model="openserviceorder.comments_financial_control"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Comments" />
                    </b-form-group>
                </b-col>
             </b-row>
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="In:"
                    label-for="openserviceorder-date_in_open_service"
                    >
                    <b-form-input
                    id="openserviceorder-date_in_open_service"
                    type="time"
                    v-model="openserviceorder.date_in_open_service"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Out:"
                    label-for="openserviceorder-date_out_open_service"
                    >
                    <b-form-input
                    id="openserviceorder-date_out_open_service"
                    type="time"
                    v-model="openserviceorder.date_out_open_service"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                        label="Payment Value:"
                        label-for="openserviceorder-value_total_open_service"
                    >
                        <b-form-input
                            id="openserviceorder-value_total_open_service"
                            type="number"
                            v-model="openserviceorder.value_total_open_service"
                            size="sm"
                            step="0.02"
                            :readonly="true"
                            pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                        />
                    </b-form-group>
             </b-col>
             </b-row>
           
        <br>
         </b-form>
         <hr />
             <b-row v-show="mode !== 'save' && mode !== 'remove'">
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="Start Service Order:"
                    label-for="orderservice-start_date"
                    >
                    <b-form-input
                    id="orderservice-start_date"
                    type="date"
                    v-model="start_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="2" sm="12">
                    <b-form-group
                    label="End Service Order:"
                    label-for="orderservice-end_date"
                    >
                    <b-form-input
                    id="orderservice-end_date"
                    type="date"
                    v-model="end_date"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                 <b-col md="4" sm="12">
                    <b-form-group 
                        label="Status">
                    <b-form-radio-group
                        size="lg"
                        v-model="receipt"
                        @input="loadServiceOrders"
                        :options="optionsStatus"
                        name="orderservice-receipt"
                    ></b-form-radio-group>  
                    </b-form-group>    
                </b-col>
             </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                     <b-col md="8" sm="12">
                        <b-form-group >
                            <b-form-input id="openserviceorder-entity_for_financial_control" 
                                type="text"
                                v-model="search" 
                                size="sm"
                                placeholder="Search by Location ..." />
                        </b-form-group>
                    </b-col>
            </b-row>
        <b-card class="order-search-card">
        <b-tabs card >
        <b-tab title="Service Order" active>
            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadServiceOrders(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                  
                </b-col>
            </b-row>          
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.finished_open_service && data.item.date_in_open_service && data.item.date_out_open_service"
                        title = "Approval" 
                        size="sm" 
                        variant="light" 
                        @click="[openModalReceipt(data.item)]" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>          
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadFinancialControl(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                      <b-button
                        title = "Attachment Financial Control"
                        size="sm"
                        @click="setFinancialControl(data.item)"
                        variant="light"
                        class="mr-2 mt-2 fa fa-plus"
                        v-b-modal.modalFile
                        > 
                    </b-button>
                    <b-button
                        title="View File"
                        size="sm"
                        variant="light"
                        v-if="data.item.storage_id_openserviceorder > 0"
                        @click="loadUrl(data.item)"
                        class="mr-2 mt-2"
                    >
                    <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
        </b-tab>
        <b-tab title="Financial Provision">
            <b-row>
                <b-button size="sm" @click="selectAllRows"  class="mt-2 mb-2 ml-2" >Select all</b-button>
                <b-button size="sm" @click="clearSelected" class="mt-2 mb-2 ml-2" >Clear selected</b-button>
                <b-button size="sm" @click="showMsgBoxCreateInvoice" class="mt-2 mb-2 ml-2"  variant="success">Create Invoice</b-button>
            </b-row>
            <b-row>
                <b-col md="8" sm="12">
                        <b-form-group >
                            <b-form-input id="openserviceorder-searchFinancial" 
                                type="text"
                                v-model="searchFinancial" 
                                size="sm"
                                placeholder="Search by Invoice for ..." />
                        </b-form-group>
                    </b-col>
            </b-row>
            <b-row>
 
         <b-table 
                class="table-responsive" 
                 head-variant="dark" 
                :select-mode="selectMode"
                @row-selected="onRowSelected"
                selectable
                ref="selectableTable"
                :items="filteredListFinancial" 
                :fields="fieldFinancial">
                <template #cell(selected)="{ rowSelected }">
                    <template v-if="rowSelected">
                    <span aria-hidden="true">&check;</span>
                    <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                    <span aria-hidden="true">&nbsp;</span>
                    <span class="sr-only">Not selected</span>
                    </template>
                </template>
         </b-table> 
        </b-row>
        </b-tab>
        </b-tabs>
        </b-card>       
         <b-modal
            id="modalReceipt"
            ref="modal"
            title-tag="h6"
            title="Closing Service Order"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
        >
            <b-form>
                <b-row>
                    <b-col md="4" sm="12">
                        <b-form-group
                            label="Value Receipt:"
                            label-for="openserviceorder-value_receipt_open_service"
                        >
                            <b-form-input
                                id="openserviceorder-value_receipt_open_service"
                                type="number"
                                v-model="openserviceorder.value_receipt_open_service"
                                size="sm"
                                step="0.02"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                     </b-col>
                    <b-col md="4" sm="12">
                        <b-form-group
                        label="Due Date:"
                        label-for="openserviceorder-due_date_receipt_open_service"
                        >
                        <b-form-input
                        id="openserviceorder-due_date_receipt_open_service"
                        type="date"
                        v-model="openserviceorder.due_date_receipt_open_service"
                        size="sm"
                        />
                        </b-form-group>
                    </b-col>
                     <b-col md="4" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="openserviceorder.receipt_hour_open_service"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="openserviceorder-receipt_hour_open_service"
                                />
                                <label
                                    class="form-check-label"
                                    for="openserviceorder-receipt_hour_open_service"
                                >
                                    Receipt Hour?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="12" sm="12">
                    <b-form-group 
                        label="Invoce for:" 
                        label-for="openserviceorder-entity_id_receipt_open_service">
                        <b-select 
                            id="openserviceorder-entity_id_receipt_open_service"
                            size="sm"
                            :options="entitys" 
                            v-model="openserviceorder.entity_id_receipt_open_service" 
                            />
                    </b-form-group>
                </b-col> 
                </b-row>
                <b-row>
                     <b-col md="5" sm="12">
                        <div class="form-group">
                            <div class="form-check">
                                <input
                                    class="form-check-input"
                                    v-model="openserviceorder.finished_open_service"
                                    true-value="1"
                                    false-value="0"
                                    type="checkbox"
                                    id="openserviceorder-finished_open_service"
                                />
                                <label
                                    class="form-check-label"
                                    for="openserviceorder-finished_open_service"
                                >
                                    Approved?
                                </label>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-form>
         </b-modal> 
        <b-modal
        id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveOpenServiceImage"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".jpg, .png, .gif"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>   
      <b-modal>
            <b-carousel-slide>
                <template #img>
                <img
                    class="d-block img-fluid w-100"
                    width="1024"
                    height="480"
                    src="https://picsum.photos/1024/480/?image=55"
                    alt="image slot"
                >
                </template>
            </b-carousel-slide>
      </b-modal>
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'OpenServiceOrderSearch',
    components: {PageTitle },
    data: function() {
        return {
                slide: 0,
                sliding: null,
                selectMode: 'multi',
                mode: 'insert',
                search: '',
                searchFinancial: '',
                openserviceorder: {},
                openserviceorderimage:{},
                openserviceorderfinancialprovision:{},
                entitys:[],
                openserviceorders: [],
                openserviceorderimages:[],
                openserviceorderfinancialprovisions:[],
                immobiles: [],
                serviceproviders:[],
                defaultservicetypes:[],
                selectedFinancial: [],
                perPage: 20,
                currentPage: 1,
                currentPageFinancial: 1,
                total_plot_closed: 0,
                total_plot_open: 0,
                total_plot: 0,
                 isBusy: false,
                 showTable: false,
                 start_date: null,
                 end_date: null,
                 receipt: null,
                 operation_id: null,
                 operation_level_one_id: null,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                    {key: 'date_open_service',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_owner', label: 'Landlord', sortable: false ,variant: 'light'},
                    { key: 'description_open_service', label: 'Location', sortable: false ,variant: 'light'},
                    { key: 'name_service_provider', label: 'Service Provider', sortable: false ,variant: 'light'},
                    { key: 'value_hours_open_service', label: 'Value hour', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},
                    {key: 'date_in_open_service',label: 'In',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    {key: 'date_out_open_service',label: 'Out',sortable: true,
                            formatter: value =>
                            value ? moment(value).format('HH:mm') : '',variant: 'light'
                    },
                    { key: 'duration_minute_open_service', label: 'Minutes Worked', sortable: false ,variant: 'light'},
                    { key: 'value_total_open_service', label: 'Payment Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'value_total_receipt_open_service', label: 'Receipt Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                    { key: 'finished_open_service', label: 'Finished', sortable: false, variant: 'light',
                        formatter: value => value ? 'Yes' : 'No' },  
                    { key: 'comment_open_service', label: 'Comments', sortable: false ,variant: 'light'},
              
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldImage: [
                    { key: 'name_file', label: 'Image', sortable: false ,variant: 'light'},   
                    { key: 'actions', label: 'Action',variant: 'light' }
                ],
                fieldFinancial: [
                    {
                    key:'selected',
                    label:'...',
                    variant: 'light'
                    },
                    {key: 'date_financial_provision',label: 'Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_entity', label: 'Invoice for', sortable: false ,variant: 'light'},
                    {key: 'due_date_financial_provision',label: 'Due Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                    },   
                    { key: 'value_financial_provision', label: 'Provision Value', sortable: false ,variant: 'light' ,formatter: value => (value ? this.formatPrice(value) : 0)},
                ],
                optionsStatus: [
                        { text: 'Open', value: 0 },
                        { text: 'Closed', value: 1 },
                        { text: 'All', value: 2 }     
                ],
               
            }
        },
        computed: {
            filteredList() {
                return this.openserviceorders.filter(openserviceorder => {
                    return openserviceorder.description_open_service.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            filteredListFinancial() {
                return this.openserviceorderfinancialprovisions.filter(openserviceorder => {
                    return openserviceorder.name_entity.toLowerCase().includes(this.searchFinancial.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.openserviceorders.length
            },
            rowFinancials() {
                return this.openserviceorderfinancialprovisions.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             onSlideStart() {
                this.sliding = true
            },
            onSlideEnd() {
                this.sliding = false
            },
            selectAllRows() {
                    this.$refs.selectableTable.selectAllRows()
            },
               clearSelected() {
                    this.$refs.selectableTable.clearSelected()
            },
             async showMsgBoxApproval() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to approval the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval()
                    }
                })
            },
              showMsgBoxCreateInvoice() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to create a new invoice?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                         this.createInvoice()
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.canceled(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadServiceOrders(){
                const url = `${baseApiUrl}/openserviceorderbycompany/${this.compan.id}/?start_date=${this.start_date}&end_date=${this.end_date}&finished_open_service=${this.receipt}`
                axios(url).then(res =>{
                     this.openserviceorders = res.data
                      this.isBusy = false
                })

            },
            loadServiceOrderFinancials(){
                const url = `${baseApiUrl}/openserviceorderfinancialprovisionsbyopenservice/${this.compan.id}`
                axios(url).then(res =>{
                     this.openserviceorderfinancialprovisions = res.data
                })

            },
            loadServiceOrderImages(){
                const url = `${baseApiUrl}/openserviceorderimagesbyopenservice/${this.openserviceorder.id}`
                axios(url).then(res =>{
                     this.openserviceorderimages = res.data
                })

            },
            alterModo() {
                    this.mode = 'save'
                    this.openserviceorder = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadServiceOrders()     
                this.loadServiceOrderFinancials()         
                this.openserviceorder = {}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/openserviceordersapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadServiceOrders()

                        })
                        .catch(showError)

           },
            async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/openserviceorderscanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadServiceOrders()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.openserviceorder.id ? 'put' : 'post'
                const id = this.openserviceorder.id ? `/${this.openserviceorder.id}` : ''

                  this.openserviceorder.company_id_open_service = this.compan.id

                if(this.openserviceorder.id){
                         this.openserviceorder.user_id_open_service = this.user.id
                
                }
            
                await axios[method](`${baseApiUrl}/openserviceorders${id}`, this.openserviceorder)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.openserviceorder.id
                    axios.delete(`${baseApiUrl}/openserviceorders/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadFinancialControl(openserviceorder, mode = 'save') {
                this.mode = mode
                 if(openserviceorder.date_open_service) openserviceorder.date_open_service = this.formatDate(openserviceorder.date_open_service)
                 if(openserviceorder.date_in_open_service) openserviceorder.date_in_open_service = moment(openserviceorder.date_in_open_service).format("HH:mm")
                 if(openserviceorder.date_out_open_service) openserviceorder.date_out_open_service = moment(openserviceorder.date_out_open_service).format("HH:mm")
                this.openserviceorder = { ...openserviceorder }
                this.$refs.searchFocus.focus();
     
            },
            setFinancialControl(openserviceorder){
                 this.openserviceorder = { ...openserviceorder }
            },
            openModalReceipt(item) {
                this.openserviceorder = {
                    ...item,
                    date_open_service: this.formatDate(item.date_open_service),
                    date_in_open_service: moment(item.date_in_open_service).format("HH:mm"),
                    date_out_open_service: moment(item.date_out_open_service).format("HH:mm")
                    }
                this.$bvModal.show('modalReceipt')
            },
            loadImmobileCompany(){
                const url = `${baseApiUrl}/immobilebycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.immobiles = res.data.map(type => {
                        return { value: type.id, text: type.address_immobile + ' - ' + type.name_owner }
                    })
                
                })
            },
            loadUrl(item){
                window.open(item.url_file)
            },
            async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
            async getLastStorageFile() {
                    const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                        await axios(url).then(
                            (res) =>
                            (this.openserviceorder = {
                                ...this.openserviceorder,
                                storage_id_openserviceorder: res.data.id,
                            })
                        );
            }, 
            async saveOpenServiceImage(){
                const method = this.openserviceorderimage.id ? 'put' : 'post'
                const id = this.openserviceorderimage.id ? `/${this.openserviceorderimage.id}` : ''

                this.openserviceorderimage.open_service_order_id_image = this.openserviceorder.id

                 await axios[method](`${baseApiUrl}/openserviceorderimages${id}`, this.openserviceorderimage)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadServiceOrderImages()
                    })
                    .catch(showError)
                
            },
            async getImmobile(item) {
                    const url = `${baseApiUrl}/immobiles/${item}`;
                        await axios(url).then(
                            (res) =>
                            (this.openserviceorder = {
                                ...this.openserviceorder,
                                description_open_service: res.data.address_immobile + ' - ' +  res.data.region_immobile,
                            })
                        );
                },   
                loadServiceProvider() {
                    const url = `${baseApiUrl}/serviceprovidersbycompany/${this.compan.id}`
                        axios.get(url).then(res => {
                        this.serviceproviders = res.data.map(operation => {
                        return {
                        value: operation.id,
                        text: operation.name_service_provider
                        }
                        })
                    })
                },
                loadEntitys(){
                        const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                        axios(url).then(res =>{
                                this.entitys = res.data.map(type => {
                                return { value: type.id, text: type.name_entity + ' - ' + type.cnpj_cpf }
                            })
                        
                        })
                },
                loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
                },
                onRowSelected(items) {
                    this.selectedFinancial = items  
                },
               async createInvoice(){
                    if(this.selectedFinancial.length > 0){
                          await axios['post'](`${baseApiUrl}/createinvoicefinancialprovision`, this.selectedFinancial)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.loadServiceOrderFinancials()
                    })
                    .catch(showError)
                    }else{

                         this.$toasted.global.defaultError({ msg: 'Record was not selected' })
                    }
                }

        },
        mounted(){

                this.start_date = moment().format("YYYY-MM-DD");
                this.end_date = moment()
                .add(30, "d")
                .format("YYYY-MM-DD");

            this.loadServiceOrders()
            this.loadImmobileCompany()
            this.loadServiceProvider()
            this.loadDefaultServiceRequests()
            this.loadEntitys()
            this.loadServiceOrderFinancials()
            this.showTable = true
        }
}
</script>

<style>


    .openserviceorder-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .openserviceorder-search button{
        font-size: 0.75rem;
    }

     .openserviceorder-search select{
        font-size: 0.75rem;
    }

    .openserviceorder-search input{
        font-size: 0.75rem;
         color: black;
    }


     .openserviceorder-search textarea{
        font-size: 0.75rem;
    }

    .openserviceorder-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
        
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
         color: black;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalReceipt {
        font-size: 0.75rem;
    }

    #modalReceipt button{
        font-size: 0.75rem;
    }

     #modalReceipt input{
        font-size: 0.75rem;
        
    }

      #modalReceipt select{
        font-size: 0.75rem;
    }

      #modalReceipt label{
        font-size: 0.75rem;
        color: black;
    }

    #modalFile {
    font-size: 0.75rem;
    }

    #modalFile button{
    font-size: 0.75rem;
    }

   .order-search-card {
        font-size: 0.75rem;
         color: black;
   
    }

    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
